import { TemplateData, TemplateParams } from '.';

const pathDeadlineApproaching = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'paths',
  email: {
    buttonEnabled: true,
    buttonLink: '{{pathUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.pathDeadlineApproaching} {{expirationDate}}.
        ${messages.pathDeadlineAccess}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.pathStepDeadlineSubject}`
  },
  placeholders: {
    expirationDate: {
      label: messages.commonExpirationDate,
      example: '27.3.2024'
    },
    expirationTimeInDays: {
      label: messages.siteSettingsAccountExpirationTimeInDays,
      example: '3'
    },
    pathTitle: {
      label: messages.pathsPathTitle,
      example: 'Test path'
    },
    pathUrl: {
      label: messages.pathsPathLink,
      example: `${serverConfig.adminUrl}/paths/1`
    },
    stepNumber: {
      label: messages.pathsStepNumber,
      example: '1'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypePathDeadlineApproaching
});

export default pathDeadlineApproaching;
